import { Divider, Stack } from '@ltvco/refresh-lib/theme';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import LocalFloristIcon from '@mui/icons-material/LocalFlorist';

import {
  ChevronButton,
  TeaserAvatar,
  TeaserDetailLabel,
  TeaserDetailRow,
  TeaserDetailValue,
  TeaserInfo,
  TeaserItemContainer,
  TeaserItemRow,
  TeaserName,
} from '../components';

import type { ObituarySearchData } from 'components/DeepSearch/types';

interface ObituarySearchPreviewCardProps {
  data: ObituarySearchData;
  onTeaserClick?: (
    displayName: string,
    idType: string,
    idValue: string
  ) => void;
}

export const ObituarySearchPreviewCard = ({
  data,
  onTeaserClick,
}: ObituarySearchPreviewCardProps) => {
  if (!data.teasers.length) {
    return null;
  }

  return (
    <Stack divider={<Divider />}>
      {data.teasers.map((teaser, index) => (
        <TeaserItemContainer
          key={teaser.id || index}
          onClick={() => onTeaserClick?.(teaser.name, 'id', teaser.id)}
        >
          <TeaserItemRow>
            <TeaserAvatar>
              <LocalFloristIcon fontSize="small" />
            </TeaserAvatar>
            <TeaserInfo>
              <TeaserName variant="body1">{teaser.name}</TeaserName>
              <TeaserDetailRow>
                <TeaserDetailLabel variant="body2">
                  Date of Birth:
                </TeaserDetailLabel>
                <TeaserDetailValue variant="body2">
                  {teaser.birthYear || '-'}
                </TeaserDetailValue>
              </TeaserDetailRow>
              <TeaserDetailRow>
                <TeaserDetailLabel variant="body2">
                  Date of Death:
                </TeaserDetailLabel>
                <TeaserDetailValue variant="body2">
                  {teaser.deathYear || '-'}
                </TeaserDetailValue>
              </TeaserDetailRow>
              <TeaserDetailRow>
                <TeaserDetailLabel variant="body2">Location:</TeaserDetailLabel>
                <TeaserDetailValue variant="body2">
                  {teaser.location || '-'}
                </TeaserDetailValue>
              </TeaserDetailRow>
            </TeaserInfo>
            <ChevronButton>
              <ChevronRightIcon fontSize="small" />
            </ChevronButton>
          </TeaserItemRow>
        </TeaserItemContainer>
      ))}
    </Stack>
  );
};
